export default "__VITE_ASSET__Qi5uVtUF__"